import { useState, useCallback } from 'react';
import { api } from 'app/services';

const useSectorSuggestions = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getSuggestions = useCallback(async (businessDescription) => {
    if (!businessDescription || businessDescription.trim() === '') {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await api.getSectorSuggestions(businessDescription);

      if (response.error) {
        setError(response.error);
        setData(null);
        return;
      }

      setData(response.response.data);
    } catch (err) {
      setError(err);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, []);

  return {
    data,
    loading,
    error,
    getSuggestions,
    reset,
  };
};

export default useSectorSuggestions;
